import request from '@/utils/request';
import { userHost, newHost } from '@/global-config';

export function login(data) {
  return request({
    url: '/home/merchant-login',
    method: 'post',
    data,
  });
}

export function getCodeImg(params) {
  return request({
    url: '/home/getCaptcha',
    method: 'get',
    params,
  });
}

export function modifyPwd(data) {
  return request({
    url: '/home/findPassword',
    method: 'post',
    data,
  });
}

export function modifyPassword(data) {
  return request({
    url: '/merchant-info/modifyPassword',
    method: 'post',
    data,
  });
}

export function sendSmsCode(params) {
  return request({
    url: '/home/getForgetPasswordSms',
    method: 'get',
    params,
  });
}

export function logout(params) {
  return request({
    url: '/home/merchant-logout',
    method: 'get',
    params,
  });
}

export function getSmsByVecode(params) {
  return request({
    url: '/home/getSmsByVecode',
    method: 'get',
    params,
  });
}

// 以下为统一登陆接口
export function userLogin(data) {
  return request({
    url: '/v2/openapi/login',
    method: 'post',
    data,
    baseURL: userHost,
  });
}

export function getCaptcha(params) {
  return request({
    url: '/v2/openapi/getCaptcha',
    method: 'get',
    params,
    baseURL: userHost,
  });
}

export function sendVecode(data) {
  return request({
    url: '/v2/openapi/sendVecode',
    method: 'post',
    data,
    baseURL: userHost,
  });
}

export function UserModifyPassword(data) {
  return request({
    url: '/v2/openapi/modifyPassword',
    method: 'post',
    data,
    baseURL: userHost,
  });
}

export function userLogout(data) {
  return request({
    url: '/v2/openapi/logout',
    method: 'post',
    data,
    baseURL: userHost,
  });
}

// 以上为统一登陆接口
export function getUserInfo(data) {
  return request({
    url: '/merchant-info/getMerchantInfoByUser',
    method: 'post',
    data,
  });
}

export function filterUser(data) {
  return request({
    url: '/merchant-info/filterUser',
    method: 'post',
    data,
  });
}

export function queryMenuList(data) {
  return request({
    url: '/menu/list',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function queryCloudManageConfig(data) {
  return request({
    url: '/shareAccount/config',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function getSignDetail(data) {
  return request({
    url: '/electronic-contract/sign-detail',
    method: 'post',
    data,
  });
}
